import { Component, OnInit } from '@angular/core';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { UserService } from '../../services/user.service';
import { RouterLink, Router, CanActivate } from '@angular/router';
import Swal from 'sweetalert2';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public email: string;
  public password: string;
  public msg: string;
  public display: boolean;

  constructor(
    private firestoreService: FirestoreService,
    public authService: UserService,
    private router: Router
  ) {
    this.display = false;
  }

  ngOnInit(): void {
    sessionStorage.clear();
  }

  login() {
    const user = this.authService.login(this.email, this.password);
    user
      .then(value => {
        sessionStorage.setItem('usuario', JSON.stringify(user));
        this.router.navigateByUrl('/home');
      })
      .catch(err => {
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Nombre de usuario o contraseña incorrecta!',
          showCancelButton: true,
          confirmButtonText: 'Recuperar Contraseña?',
          showLoaderOnConfirm: false
        }).then((result) => {
          if (result.value) {
            Swal.fire({
              icon: 'question',
              text: 'Ingresa tu usuario (email).',
              input: 'email',
              inputAttributes: {
                autocapitalize: 'off'
              },
              showCancelButton: true,
              confirmButtonColor: '#28a745',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Enviar',
              showLoaderOnConfirm: false
            }).then((login) => {
              if (login.value) {
                const usuario = this.authService.forgot(login.value);
                usuario
                .then(value => {
                  Swal.fire({
                    icon: 'success',
                    title: 'Contraseña enviada',
                    showConfirmButton: false,
                    timer: 1500
                  });
                })
                .catch(Error => {
                  Swal.fire({
                    icon: 'error',
                    title: 'Usuario no encontrado',
                    showConfirmButton: false,
                    timer: 1500
                  });
                });
              }
            });
          }
        });
      });
    this.email = '';
    this.password = '';
  }
}
